const n = [
  "moon",
  "teal",
  "green",
  "cactus",
  "gold",
  "sienna",
  "red",
  "magenta",
  "purple",
  "blue"
], t = (e) => typeof e == "string" && n.includes(e);
export {
  n as COLORS,
  t as isAutoColor
};
